__turbopack_context__.v({
  "captionWrapper": "image-viewer-module-scss-module__FEM1gW__captionWrapper",
  "featuredImage": "image-viewer-module-scss-module__FEM1gW__featuredImage",
  "featuredImageAccess": "image-viewer-module-scss-module__FEM1gW__featuredImageAccess",
  "featuredImageContainer": "image-viewer-module-scss-module__FEM1gW__featuredImageContainer",
  "featuredImageContext": "image-viewer-module-scss-module__FEM1gW__featuredImageContext",
  "featuredImageMeta": "image-viewer-module-scss-module__FEM1gW__featuredImageMeta",
  "figure": "image-viewer-module-scss-module__FEM1gW__figure",
  "imageAndControls": "image-viewer-module-scss-module__FEM1gW__imageAndControls",
  "imageAndRightsContainer": "image-viewer-module-scss-module__FEM1gW__imageAndRightsContainer",
  "isButton": "image-viewer-module-scss-module__FEM1gW__isButton",
  "isRestricted": "image-viewer-module-scss-module__FEM1gW__isRestricted",
  "noAdditionalImages": "image-viewer-module-scss-module__FEM1gW__noAdditionalImages",
  "noFeaturedImageImage": "image-viewer-module-scss-module__FEM1gW__noFeaturedImageImage",
  "noFeaturedImageMessage": "image-viewer-module-scss-module__FEM1gW__noFeaturedImageMessage",
  "rightsRestrictedMessageWrapper": "image-viewer-module-scss-module__FEM1gW__rightsRestrictedMessageWrapper",
  "rtl": "image-viewer-module-scss-module__FEM1gW__rtl",
  "rtlText": "image-viewer-module-scss-module__FEM1gW__rtlText",
  "selectedThumbnail": "image-viewer-module-scss-module__FEM1gW__selectedThumbnail",
  "shelfContainer": "image-viewer-module-scss-module__FEM1gW__shelfContainer",
  "thumbnail": "image-viewer-module-scss-module__FEM1gW__thumbnail",
  "wrapper": "image-viewer-module-scss-module__FEM1gW__wrapper",
});
